
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-[#0E1A2B] pt-24">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-8 py-32 text-center w-full">
        <h1 className="font-serif text-5xl md:text-7xl text-[#F7F5F2] leading-tight mb-8">
          AI systems built for the practice of law.
        </h1>
        
        <div className="w-24 h-px bg-[#C8A14A] mx-auto mb-8"></div>
        
        <p className="text-xl md:text-2xl text-[#8A8F98] leading-relaxed mb-16 max-w-3xl mx-auto">
          We help law firms operate with greater precision, faster response times, and measurable efficiency—without compromising professionalism, confidentiality, or compliance.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <button 
            onClick={() => scrollToSection('cta')}
            className="px-10 py-4 bg-[#C8A14A] text-[#0E1A2B] text-base font-semibold tracking-wide hover:bg-[#d4af5e] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Request a Private Consultation
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="px-10 py-4 border-2 border-[#F7F5F2] text-[#F7F5F2] text-base font-semibold tracking-wide hover:bg-[#F7F5F2] hover:text-[#0E1A2B] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Our Legal Systems
          </button>
        </div>
      </div>
    </section>
  );
}
